<template>
	<div class="chat-container w-100 position-relative bg-white">
		<div class="w-100 pb-4 mb-4 border-b-semi-grey" v-if="is_load.top">
			<b-skeleton-img no-aspect width="100%" height="250px"></b-skeleton-img>
			<div class="mt-3 px-4 w-100">
				<b-skeleton width="70%" height="30px"></b-skeleton>
				<b-skeleton width="40%" height="20px"></b-skeleton>
				<b-skeleton width="60%" height="20px"></b-skeleton>
			</div>
		</div>
		<template v-else>
			<!-- SLIDER -->
			<div class="w-100 position-relative">
				<HomeNavbar @shareClick="shareClick" @callClick="callClick" />
				<flickity ref="flickity" :options="headerScrollSlider" v-if="getMerchant.merchant_images.length > 0">
					<div class="carousel-cell w-100" :id="slider_merchant.id" v-for="(slider_merchant,index) in  getMerchant.merchant_images">
						<div class="w-100" style="height: 250px !important;" @click="goToDetailSlider(slider_merchant)">
							<img :src="slider_merchant.image_url" class="img-fit" :alt="index+1" height="250" @click="showGallery(true)">
						</div>
					</div>
				</flickity>
				<div class="position-absolute" @click="showGallery(true)" v-if="getMerchant.merchant_images.length > 1" style="right: 24px;top: 200px;">
					<img src="../../assets/img/icon/menu-navbar/Image-More.svg" alt="More" width="32">
				</div>	    
			</div>

			<!-- PROMO -->
			<template v-if="data_parent.promo.length > 0">
				<router-link :to="'/'+getMerchant.code+'/promo'">
					<div class="promo-mobile position-relative px-4 py-3">
						<div class="row no-gutters">
							<div class="col-1">
								<div class="d-inline-block icon">
									<img src="../../assets/img/icon/menu-navbar/Promo.svg" alt="Promo" width="42">
								</div>
							</div>
							<div class="col-10">
								<div class="d-inline-block text">
									<p class="mb-0 body-1-2 text-15 font-semibold position-relative z-index-1038">{{$t('hotel.concierge.fitur.there-are')}} {{data_parent.promo.length}} {{$t('hotel.concierge.fitur.interesting-promos')}}</p>
									<p class="mb-0 body-1-2 text-12 font-regular">{{$t('hotel.concierge.fitur.click-to-get-attractive-promos')}}</p>
								</div>
							</div>
							<div class="col-1 text-right">
								<img src="../../assets/img/icon/back-arrow.png" class="mt-2 transform-180" alt="Promo" width="12">
							</div>
							<div class="bg">
								<img src="../../assets/img/icon/menu-navbar/Promo-Bg.svg" alt="Promo" class="w-100">
							</div>
						</div>
					</div>
				</router-link>
			</template>
			
			<!-- TITLE -->
			<div class="p-4 border-b-semi-grey mb-4">
				<p class="mb-0 font-bold body-2-2 text-22">{{getMerchant.name}}</p>
				<div class="mr-3 d-inline-block">
					<div class="w-100 mb-1" v-if="getMerchant.star>0">
						<svg v-for="n in getMerchant.star"  class="d-inline-block align-middle" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M13.4389 10.7401C13.2447 10.9284 13.1554 11.2006 13.1997 11.4676L13.8664 15.1576C13.9227 15.4704 13.7907 15.7869 13.5289 15.9676C13.2724 16.1551 12.9312 16.1776 12.6514 16.0276L9.32966 14.2951C9.21416 14.2336 9.08591 14.2006 8.95466 14.1969H8.75141C8.68091 14.2074 8.61191 14.2299 8.54891 14.2644L5.22641 16.0051C5.06216 16.0876 4.87616 16.1169 4.69391 16.0876C4.24991 16.0036 3.95366 15.5806 4.02641 15.1344L4.69391 11.4444C4.73816 11.1751 4.64891 10.9014 4.45466 10.7101L1.74641 8.08512C1.51991 7.86537 1.44116 7.53537 1.54466 7.23762C1.64516 6.94062 1.90166 6.72387 2.21141 6.67512L5.93891 6.13437C6.22241 6.10512 6.47141 5.93262 6.59891 5.67762L8.24141 2.31012C8.28041 2.23512 8.33066 2.16612 8.39141 2.10762L8.45891 2.05512C8.49416 2.01612 8.53466 1.98387 8.57966 1.95762L8.66141 1.92762L8.78891 1.87512H9.10466C9.38666 1.90437 9.63491 2.07312 9.76466 2.32512L11.4289 5.67762C11.5489 5.92287 11.7822 6.09312 12.0514 6.13437L15.7789 6.67512C16.0939 6.72012 16.3572 6.93762 16.4614 7.23762C16.5597 7.53837 16.4749 7.86837 16.2439 8.08512L13.4389 10.7401Z" fill="#FFD938"/>
						</svg>
					</div>
					<p class="mb-0 body-2-2 text-14 font-medium"> 
						<router-link :to="'/'+getMerchant.code+'/feedback'" v-if="summary > 0" class="text-semi-dark" @click.native="$postLog('HOME','NAVBAR','Clicked menu review')">
							<u>({{summary}}) {{$t('general.reviews')}}</u>
						</router-link>
					</p>
				</div>
				<div class="d-inline-block w-100 pb-2" @click="isLocation()">
					<svg class="d-inline-block" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M2.625 7.73832C2.625 4.28842 5.50791 1.5 8.99508 1.5C12.4921 1.5 15.375 4.28842 15.375 7.73832C15.375 9.47677 14.7428 11.0907 13.7021 12.4587C12.5541 13.9676 11.1391 15.2823 9.54641 16.3143C9.18188 16.5528 8.85291 16.5708 8.45284 16.3143C6.85105 15.2823 5.43607 13.9676 4.29787 12.4587C3.25649 11.0907 2.625 9.47677 2.625 7.73832ZM6.89567 7.93256C6.89567 9.08828 7.83874 9.99725 8.99508 9.99725C10.1522 9.99725 11.1043 9.08828 11.1043 7.93256C11.1043 6.78585 10.1522 5.83262 8.99508 5.83262C7.83874 5.83262 6.89567 6.78585 6.89567 7.93256Z" fill="#222222"/>
					</svg>
					<p class="mb-0 body-2-2 text-14 font-medium d-inline-block w-90 text-truncate position-relative" style="top:6px"><u>{{getMerchant.address}}</u></p>
				</div>
			</div>
		</template>

		<!-- RESERVATION DETAIL -->
		<div class="w-100 pb-4 px-4 mb-4 border-b-semi-grey" v-if="is_load.reservation">
			<b-row class="slim-grid-row">
				<b-col cols="12" class="mb-3">
					<b-skeleton width="20%" height="30px"></b-skeleton>
				</b-col>
				<b-col cols="12">
					<b-card body-class="p-3">
						<b-row no-gutters>
							<b-col cols="4" class="align-self-center">
								<b-row class="slim-grid-row">
									<b-col cols="6">
										<b-skeleton width="100%" height="57px"></b-skeleton>
									</b-col>
									<b-col cols="6">
										<b-skeleton width="100%" height="15px"></b-skeleton>
										<b-skeleton width="80%" height="15px"></b-skeleton>
										<b-skeleton width="60%" height="15px"></b-skeleton>
									</b-col>
								</b-row>
							</b-col>
							<b-col cols="3" offset="5" class="align-self-center">
								<b-skeleton width="100%" height="40px"></b-skeleton>
							</b-col>
							<b-col cols="12" class="my-3">
								<div class="w-100 border-2-bottom-dashed"></div>
							</b-col>
							<b-col cols="4">
								<b-skeleton width="30%" height="15px"></b-skeleton>
								<b-skeleton width="50%" height="20px"></b-skeleton>
							</b-col>
							<b-col cols="4">
								<b-skeleton width="30%" height="15px"></b-skeleton>
								<b-skeleton width="50%" height="20px"></b-skeleton>
							</b-col>
							<b-col cols="4">
								<b-skeleton width="30%" height="15px"></b-skeleton>
								<b-skeleton width="50%" height="20px"></b-skeleton>
							</b-col>
							<b-col cols="12" class="my-3">
								<div class="w-100 border-2-bottom-dashed"></div>
							</b-col>
							<b-col cols="12">
								<b-skeleton width="70%" height="20px"></b-skeleton>
							</b-col>
						</b-row>
					</b-card>
				</b-col>
			</b-row>
		</div>
		<template v-else>
			<div class="w-100 mb-5 px-4" v-if="data_parent.reservation.id">
				<div class="w-100 pb-4 mb-5 border-b-semi-grey">
					<p class="sub-heading-1-1 mb-3 text-semi-dark">Reservation Detail</p>
					<div class="w-100 border-semi-grey radius-8 p-3">
						<div class="row no-gutters">
							<div class="col-12 text-center py-3" v-if="data_parent.reservation_load">
								<loader />
							</div>
							<template v-else>
								<div class="col-2 align-self-center">
									<div class="w-100 pr-2">
										<div class="w-100 bg-orange text-center radius-8" style="padding:13px 0px;">
											<i class="simple-icon-home text-18 text-white"></i>
										</div>
									</div>
								</div>
								<div class="col-7 align-self-center">
									<div class="pr-2">
										<p class="mb-0 body-2-1" :class="{'text-danger': data_parent.reservation.room_type.name == 'Unallocated Room Type'}">{{data_parent.reservation.room_type.name}}</p>
										<div class="w-100 no-ws">
											<p class="mb-0 d-inline-block align-middle body-3-3-1 mr-2">Room : </p>
											<p class="mb-0 d-inline-block align-middle body-3-1" :class="{'text-danger': data_parent.reservation.room.name == 'Unallocated'}">{{data_parent.reservation.room.name}}</p>
										</div>
										<p class="mb-0 body-3-1 text-info">Folio {{data_parent.reservation.folio_number != '' ? `#${data_parent.reservation.folio_number}` : '#'}}</p>
									</div>
								</div>
								<div class="col-3 align-self-center text-right">
									<p class="mb-0 body-3-3-1">Status</p>
									<p class="mb-0 body-3-1" :class="reservation_status.text_color">{{reservation_status.title}}</p>
								</div>
								<div class="col-12 my-3">
									<div class="w-100 border-2-bottom-dashed"></div>
								</div>
								<div class="col-6">
									<p class="mb-0 body-3-3-1">Check in</p>
									<p class="mb-0 body-3-1">{{$formatDate(data_parent.reservation.arrival_date,'YYYY-MM-DD')}}</p>
								</div>
								<div class="col-6">
									<p class="mb-0 body-3-3-1">Check out</p>
									<p class="mb-0 body-3-1">{{$formatDate(data_parent.reservation.departure_date,'YYYY-MM-DD')}}</p>
								</div>
								<div class="col-12 my-3">
									<div class="w-100 border-b-semi-grey"></div>
								</div>
								<div class="col-12 text-center">
									<p class="mb-0 body-3-1">{{reservation_status.description}}</p>
								</div>
								<div class="col-12 mt-2" v-if="data_parent.reservation.status == 'SUBMIT_FORM' || data_parent.reservation.status == 'PRE_CHECKIN' || data_parent.reservation.status == 'CHECKIN' || (getMerchant.reservation_detail_show_bill && isCurrentUserSameWithRsvUser)">
									<button type="button" v-if="data_parent.reservation.status == 'SUBMIT_FORM' || data_parent.reservation.status == 'PRE_CHECKIN'" class="g-btn w-100 g-btn-primary g-btn-md" :class="getMerchant.reservation_detail_show_bill && isCurrentUserSameWithRsvUser ? 'mb-2' : ''" @click="checkStatus()">Check Status</button>
									<button v-if="getMerchant.reservation_detail_show_bill && isCurrentUserSameWithRsvUser" type="button" class="g-btn w-100 g-btn-secondary-outline g-btn-md" @click="openGuestBill()">Guest Bill</button>
								</div>
							</template>
						</div>
					</div>
				</div>
			</div>
		</template>

		<!-- ROOM TYPE -->
		<RoomTypePreviewMobile  v-if="getMerchant.use_booking_engine && getMerchant.is_show_room_type" data_source="parent" :parent_data="data_parent.room_type" :is_load="is_load.room_type"></RoomTypePreviewMobile>


    <div class="px-4">
    	<!-- MENU SERVICE -->
			<div class="w-100 pb-4 mb-4 border-b-semi-grey" v-if="is_load.small_menu">
				<b-row class="slim-grid-row">
					<b-col cols="12" class="mb-3">
						<b-skeleton width="20%" height="40px"></b-skeleton>
						<b-skeleton width="50%" height="20px"></b-skeleton>
					</b-col>
					<b-col cols="12" class="mb-3" v-for="i in 2" :key="i">
						<b-card no-body img-left>
							<b-skeleton-img no-aspect width="35%" height="95px" card-img="left"></b-skeleton-img>
							<b-card-body class="p-2">
								<b-skeleton width="40%" height="20px"></b-skeleton>
								<b-skeleton width="60%" height="15px" class="mb-2"></b-skeleton>
								<b-skeleton width="20%" height="20px" class="d-table ml-auto mb-0"></b-skeleton>
							</b-card-body>
						</b-card>
					</b-col>
				</b-row>
			</div>
			<template v-else>
				<div class="w-100 pb-4 pt-1 mb-5 border-b-semi-grey" v-if="data_parent.menu.length > 0">
					<p class="sub-heading-1-1 mb-1 text-semi-dark">{{$t('hotel.concierge.fitur.book-our-services')}}</p>
					<p class="body-2-2-1 mb-3 sub-title">{{$t('hotel.concierge.fitur.fitur-desc')}}</p>
					<!-- MENU ITEM -->
					<div 
						class="" 
						v-for="(menu_service,index) in data_parent.menu"
						:key="index">
						<div class="row border-semi-grey radius-12 mb-3 no-gutters"
							v-if="menu_service.service_type == 'MERCHANT_POS'"
							@click="detailModuleClick(menu_service.merchant_pos.code)">
							<div class="col-4 radius-12" style="height: 95px;" v-if="menu_service.service_type == 'MERCHANT_POS'">
								<img v-if="menu_service.merchant_pos.slider.length == 1" :src="menu_service.merchant_pos.slider[0].image_url" class="img-fit radius-12-l" :alt="getMerchant.name">
								<flickity v-else ref="flickity" class="mb-3" :options="freeScrollSlider">
									<div class="carousel-cell w-100" style="height: 95px;" v-for="menu_slider in menu_service.merchant_pos.slider">
										<img :src="menu_slider.image_url" class="img-fit radius-12-l" :alt="getMerchant.name">
									</div>
								</flickity>
							</div>
							<div class="col-8">
								<div class="w-100 px-3 py-2">
									<p class="body-1-2 mb-1 position-relative text-truncate" style="top:4px">{{menu_service.merchant_pos.tagline}}</p>
									<p class="body-2-2-1 mb-0 text-truncate">{{menu_service.merchant_pos.sub_tagline}}</p>
									<div class="w-100 mt-1">
										<div class="d-table link-green-arrow ml-auto" @click="detailModuleClick(menu_service.merchant_pos.code)">
											<p class="mb-0 d-inline-block aling-middle text-12">{{$t('hotel.concierge.fitur.read-more')}}</p>
											<i class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-10" ></i>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>

	    <!-- MENU SERVICE PREVIEW -->
			<div class="w-100 pb-4 mb-4 border-b-semi-grey" v-if="is_load.big_menu">
				<b-row class="slim-grid-row">
					<b-col cols="12" class="mb-3">
						<b-skeleton width="20%" height="40px"></b-skeleton>
						<b-skeleton width="50%" height="20px"></b-skeleton>
					</b-col>
					<b-col cols="12">
						<b-card>
							<b-row class="mb-4">
								<b-col cols="12" class="mb-3">
									<b-skeleton width="20%" height="25px"></b-skeleton>
									<b-skeleton width="50%" height="15px"></b-skeleton>
								</b-col>
								<b-col cols="8">
									<b-skeleton-img no-aspect width="100%" height="185px"></b-skeleton-img>
								</b-col>
								<b-col cols="4">
									<b-skeleton-img no-aspect width="100%" height="185px"></b-skeleton-img>
								</b-col>
							</b-row>
							<b-row>
								<b-col cols="12" class="mb-2">
									<b-skeleton width="20%" height="25px"></b-skeleton>
									<b-skeleton width="50%" height="15px"></b-skeleton>
								</b-col>
								<b-col cols="4" v-for="i in 3" :key="i">
									<b-skeleton-img no-aspect width="100%" height="120px"></b-skeleton-img>
									<b-skeleton width="40%" height="20px" class="mt-3"></b-skeleton>
									<b-skeleton width="50%" height="15px"></b-skeleton>
								</b-col>
							</b-row>
						</b-card>
					</b-col>
				</b-row>
			</div>
			<template v-else>
				<div class="w-100 pb-5 border-b-semi-grey mb-5" v-for="(menu_preview,index) in data_parent.preview" v-if="menu_preview.service_type == 'MERCHANT_POS'">
					<p class="sub-heading-1-1 mb-1 text-semi-dark">{{menu_preview.tagline}}</p>
					<p class="body-2-2-1 mb-3 sub-title">{{menu_preview.sub_tagline}}</p>
					<RoomDiningPreview 
						v-if="menu_preview.merchant_pos.code=='concierge-room-dining'"
						type="mobile"
						:data="menu_preview" />
					<ThingsToDoPreview
						v-if="menu_preview.merchant_pos.code=='concierge-experience'"
						type="mobile"
						:data="menu_preview.merchant_pos" />
					<SpaPreview
						v-if="menu_preview.merchant_pos.code=='concierge-spa'"
						type="mobile"
						:data="menu_preview.merchant_pos" />
					<LaundryPreview
						v-if="menu_preview.merchant_pos.code=='concierge-laundry'"
						type="mobile"
						:data="menu_preview" />
				</div>

				<div class="w-100 pb-5" v-for="(upselling,index) in data_parent.preview" v-if="upselling.service_type == 'UPSELLING_PRODUCT_GROUP'">
					<p class="sub-heading-1-1 mb-1 text-semi-dark">{{upselling.tagline}}</p>
					<p class="body-2-2-1 mb-3 sub-title">{{upselling.sub_tagline}}</p>
					<VoucherPreview
						type="mobile"
						:data="upselling" />
				</div>
			</template>

			<div class="w-100 pb-4 mb-4 border-b-semi-grey" v-if="is_load.bottom">
				<b-row class="slim-grid-row">
					<b-col cols="12" class="mb-3">
						<b-skeleton width="20%" height="40px"></b-skeleton>
						<b-skeleton width="50%" height="20px"></b-skeleton>
					</b-col>
					<b-col cols="6" v-for="i in 2" :key="i">
						<b-card no-body img-left>
							<b-skeleton-img no-aspect width="35%" height="58px" card-img="left"></b-skeleton-img>
							<b-card-body class="p-2">
								<b-skeleton width="40%" height="20px"></b-skeleton>
								<b-skeleton width="60%" height="15px" class="mb-0"></b-skeleton>
							</b-card-body>
						</b-card>
					</b-col>
				</b-row>
			</div>
			<template v-else>
				<!-- SOCIAL MEDIA -->
				<div class="w-100 mb-5" v-if="getMerchant.social_media.length > 0">
					<p class="sub-heading-1-1 mb-1 text-semi-dark">{{getMerchant.merchant_social_media_title}}</p>
					<p class="body-2-2-1 mb-3 sub-title">{{getMerchant.merchant_social_media_subtitle}}</p>
					<div class="w-100">
						<div class="w-100 mb-3" v-for="(sosmed,index) in getMerchant.social_media" :key="index">
							<CustomUrl :data="sosmed" type="social_media"></CustomUrl>
						</div>
					</div>
				</div>

				<!-- CUSTOM URL -->
				<div class="w-100 mb-5" v-if="getMerchant.merchant_link.length > 0">
					<p class="sub-heading-1-1 mb-1 text-semi-dark">{{getMerchant.merchant_link_title}}</p>
					<p class="body-2-2-1 mb-3 sub-title">{{getMerchant.merchant_link_subtitle}}</p>
					<div class="w-100">
						<div class="w-100 mb-3" v-for="(custom_url,index) in getMerchant.merchant_link" :key="index">
							<CustomUrl :data="custom_url" type="custom"></CustomUrl>
						</div>
					</div>
				</div>

				<!-- OTHER INFORMATION -->
				<div class="w-100 mb-5" v-if="getMerchant.check_in_time_start != '' && getMerchant.check_out_time_start != ''">
					<p class="mb-3 sub-heading-1-1">{{$t('general.about-accommodation')}}</p>
					<div class="mb-3" v-if="getMerchant.description != ''">
						<!-- <p class="mb-2 body-3-3 text-16 font-bold">{{$t('general.description')}}</p> -->
						<div class="mb-4 body-3-3 text-15 font-medium text-truncate-10 html-desc" v-html="getMerchant.description"></div>
						<p class="mb-0 body-2-1 d-table cursor-pointer text-green border-bottom-green"
							@click="togglePopupInfo($t('general.about-accommodation'),getMerchant.description)">
							Read More
						</p>
					</div>
					<div class="row">
						<div class="col-6">
							<div class="border-semi-grey radius-12 py-2 text-center">
								<p class="mb-0 body-2-2-1">{{$t('hotel.check-in-time')}}</p>
								<p class="mb-0 body-1-2">{{formatTime(getMerchant.check_in_time_start)}}</p>
								<p class="mb-0 body-3-3-1">UTC{{getMerchantTimezone.offset}}</p>
							</div>
						</div>
						<div class="col-6">
							<div class="border-semi-grey radius-12 py-2 text-center">
								<p class="mb-0 body-2-2-1">{{$t('hotel.check-out-time')}}</p>
								<p class="mb-0 body-1-2">{{formatTime(getMerchant.check_out_time_end)}}</p>
								<p class="mb-0 body-3-3-1">UTC{{getMerchantTimezone.offset}}</p>
							</div>
						</div>
					</div>
				</div>


				<div class="w-100 mb-5" v-if="getMerchant.facilities.length > 0">
					<p class="mb-3 sub-heading-1-1">{{$t('general.facilities')}}</p>
					<div class="w-100 mb-3">
						<template v-for="(facility,index) in getMerchant.facilities">
							<div class="w-100 mb-3" v-if="index < 5">
								<Facility :data="facility"></Facility>
							</div>
						</template>
					</div>
					<div class="w-100 radius-12 text-center mt-3 g-btn-lg border-green" @click="toggleFacility" v-if="getMerchant.facilities.length > 5">
						<p class="mb-0 d-inline-block aling-middle">{{$t('hotel.concierge.fitur.load-more')}}</p>
						<i class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-12" ></i>
					</div>
				</div>

				<div class="w-100 mb-5" id="location">
					<p class="mb-3 sub-heading-1-1">{{$t('general.location')}}</p>
					<p class="mb-2 body-2-2-1"><img src="../../assets/img/hotel/marker.png" class="mr-2" width="15" :alt="getMerchant.name"> {{getMerchant.address}}</p>
					<div class="w-100 pb-4">
						<ShowGmaps/>
					</div>
				</div>

				<!-- PARTNER PREVIEW -->
				<div v-if="getMerchant.verified_by.length > 0">
					<PartnerPreview></PartnerPreview>
				</div>
				<div class="mb-5 w-100">
					<div class="border-b-semi-grey py-2 mb-2 cursor-pointer" v-if="getMerchant.terms_and_conditions != ''" @click="togglePopupInfo($t('hotel.concierge.fitur.terms-conditions'),getMerchant.terms_and_conditions)">
						<div class="row slim-grid-row">
							<div class="col-11">
								<p class="mb-0 body-3-3 text-16 font-bold">{{$t('hotel.concierge.fitur.terms-conditions')}}</p>
							</div>
							<div class="col-1">
								<i class="simple-icon-arrow-right mt-2"></i>
							</div>
						</div>
					</div>
					<div class="border-b-semi-grey py-2 my-2 cursor-pointer" v-if="getMerchant.cancellation_policy != ''" @click="togglePopupInfo($t('merchant.cancellation-policy'),getMerchant.cancellation_policy)">
						<div class="row slim-grid-row">
							<div class="col-11">
								<p class="mb-0 body-3-3 text-16 font-bold">{{$t('merchant.cancellation-policy')}}</p>
							</div>
							<div class="col-1">
								<i class="simple-icon-arrow-right mt-2"></i>
							</div>
						</div>
					</div>
				</div>
			</template>																	
    </div>

    <!-- FLOATING MENU -->
    <transition name="fade">
      <template v-if="!is_load.be && show_booking_engine_section">
        <div class="position-relative" style="z-index: 1027;">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-block" style="bottom:0px">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                    <div class="container bg-white px-4 py-12px" style="box-shadow: 0px -3px 13px 0px #0000000f">
                      <div class="row">
                        <template>
                          <div class="col-6">
                          	<template v-if="getMerchant.use_booking_engine && data_parent.lowest_price>0">
	                            <p class="mb-0 body-2-2 text-12" style="padding-top:2px">{{$t('merchant.starting-from')}}</p>
	                            <p class="mb-0 body-2-2 text-18 text-orange font-bold d-inline-block">{{$formatCurrency(data_parent.lowest_price)}}</p>
	                          </template>
                          </div>
                          <div class="col-6 text-right" @click="$postLog('HOME','','Clicked Find Rooms')">
                          	<button v-if="getMerchant.use_custom_booking_engine_landing_page" type="button" class="g-btn g-btn-primary g-btn-lg" style="padding-top:12px;padding-bottom:12px" @click="goToCustomBookingPage">{{$t('hotel.action.book-now')}}</button>
                            <router-link v-else :to="'/'+getMerchant.code+'/booking'">
															<button type="button" class="g-btn g-btn-primary g-btn-lg" style="padding-top:12px;padding-bottom:12px">{{$t('hotel.action.book-now')}}</button>
														</router-link>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </transition>

    

    <!-- DETAIL FACILITY -->
    <popup-detail 
    	direction="bottom" 
    	:show="show_facility"
    	:use_max_size="true"
    	:title="$t('general.facilities')"
    	@close="toggleFacility">
    	<template v-slot:body>
	    	<div class="py-3 px-4">
	        <div class="w-100">
	        	<template v-for="(facility,index) in getMerchant.facilities">
	        		<div class="w-100 mb-3">
	        			<Facility :data="facility"></Facility>
	        		</div>
		        </template>
	        </div>
	    	</div>
	    </template>
    </popup-detail>

    <!-- DETAIL BASIC INFORMATION -->
    <popup-detail 
    	direction="bottom" 
    	:show="popup_info.show"
    	:use_max_size="true"
    	:title="popup_info.title"
    	@close="togglePopupInfo">
    	<template v-slot:body>
	    	<div class="py-3 px-4">
	        <div class="html-desc" v-html="popup_info.body">
	        </div>
	    	</div>
	    </template>
    </popup-detail>
    <!-- GALLERY -->
  	<transition name="fade">
 			<template v-if="is_gallery">
	    	<div class="container">
		      <div class="fixed-top d-block nav-bottom bg-white pop-up fit-to-screen scroll-hide-mobile z-index-1042 w-100">
		        <div class="custom-container-fluid px-0">
		          <div class="row justify-content-center no-gutters">
		            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
		              <div class="container px-4 pb-4">
		              	<div class="position-sticky w-100 bg-white top-0 z-index-1036 py-3">
		              		<div class="row">
		              			<div class="col-2" @click="showGallery(false)">
		              				<img src="../../assets/img/icon/back.png" class="cursor-pointer" width="20">
		              			</div>
		              			<div class="col-10 text-right">
		              				<router-link :to="'/'+getMerchant.code+'/gallery'" class="d-inline-block" @click.native="$postLog('HOME','NAVBAR','Clicked menu gallery')">
														<img 
									    				src="../../assets/img/icon/menu-navbar/Image.png" 
									    				width="20"
									    				:alt="getMerchant.name">
								    				<p class="mb-0 body-1-2 d-inline-block position-relative" style="top:1px">{{$t('restaurant.menu.gallery')}}</p>
													</router-link>
		              			</div>
		              		</div>
		              	</div>
		              	<div class="row slim-grid-row-1">
			              	<div class="col-6 mb-2" 
			              		:class="{'col-12': index_image_slider == 0 || index_image_slider == 3 || index_image_slider == 8}" 
			              		v-for="(image_slider,index_image_slider) in getMerchant.merchant_images" 
			              		:key="index_image_slider" 
			              		@click="index = index_image_slider">
			              		<img :src="image_slider.image_url" class="object-fit w-100" :alt="getMerchant.name" height="200">
			              	</div>
			              </div>
		              </div>
		            </div>
		          </div>
		        </div>
		      </div>
		      <CoolLightBox 
			      :items="getMerchant.merchant_images"
			      srcName="image_url" 
			      :index="index"
			      :closeOnClickOutsideMobile="true"
			      @close="index = null">
			    </CoolLightBox>
		    </div>
  		</template>
	  </transition>
    <div class="height-50px" v-if="getMerchant.use_booking_engine"></div>
    <!-- GUEST BILL -->
    <GuestBill ref="guest_bill"></GuestBill>
	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
	import {get} from '@/services/index.js';
	import {calculateFinalPriceConcierge} from '@/utils/index.js'
  import Flickity from 'vue-flickity';
  import CustomUrl from '@/components/hotel/general/CustomUrl'
  import Facility from '@/components/hotel/general/Facility'
  import RoomDiningPreview from '@/components/hotel/general/RoomDiningPreview'
  import ThingsToDoPreview from '@/components/hotel/general/ThingsToDoPreview'
  import SpaPreview from '@/components/hotel/general/SpaPreview'
  import LaundryPreview from '@/components/hotel/general/LaundryPreview'
  import VoucherPreview from '@/components/hotel/general/VoucherPreview'
  import GuestBill from '@/components/hotel/general/GuestBill'
  import moment from 'moment';
  import CoolLightBox from 'vue-cool-lightbox'
	import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
	import HomeNavbar from '@/components/hotel/be/mobile/HomeNavbar'
	import RoomTypePreviewMobile from '@/components/hotel/general/RoomTypePreviewMobile'
  import PartnerPreview from '@/components/hotel/general/PartnerPreview'

	export default{
		props: ['data_parent'],
		components:{
			Flickity,
			CustomUrl,
			Facility,
			RoomDiningPreview,
			ThingsToDoPreview,
			SpaPreview,
			LaundryPreview,
			VoucherPreview,
			CoolLightBox,
			GuestBill,
			HomeNavbar,
			RoomTypePreviewMobile,
			PartnerPreview
		},
		data(){
			return{
				topSliderOption: {
          initialIndex: 0,
          autoPlay: 3000,
          prevNextButtons: false,
          pageDots: true,
          adaptiveHeight: false,
          draggable: true,
          wrapAround: true,
        },
        headerScrollSlider: {
          initialIndex: 0,
          autoPlay: 5000,
          prevNextButtons: false,
          pageDots: true,
          adaptiveHeight: false,
          draggable: true,
          wrapAround: false,
          contain: false
        },
        freeScrollSlider: {
          initialIndex: 0,
          autoPlay: 5000,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: false,
          draggable: true,
          wrapAround: false,
          contain: true
        },
        scrollPosition: 0,
        show_navbar: false,
        show_facility: false,
        popup_info:{
        	show: false,
        	title: '',
        	body: ''
        },
        is_gallery: false,
        index: null,
        summary:"",
        reservation_pin: '',
        reservation_pin_error: ''
			}
		},
		computed:{
			...mapGetters(['getMerchant','getBeFilter','getCurrentLanguage','getCurrency','getMerchantTimezone','isLoggedIn','isCurrentUserSameWithRsvUser', 'isReservationActive']),
			reservation_status(){
				if(this.data_parent.reservation.id){
					let return_data = {
						title: '',
						text_color: '',
						description: ''
					}

					if(this.data_parent.reservation.status == 'SUBMIT_FORM'){
						return_data = {
							title: 'Waiting for Approval',
							text_color: 'text-secondary',
							description: 'Your data is waiting for approval by the front office. Please wait until the process done.'
						}
					}else if(this.data_parent.reservation.status == 'PRE_CHECKIN' || this.data_parent.reservation.status == 'CHECKIN'){
						return_data = {
							title: this.data_parent.reservation.status == 'PRE_CHECKIN' ? 'Pre Check In' : 'Check In',
							text_color: this.data_parent.reservation.status == 'PRE_CHECKIN' ? 'text-info' : 'text-success',
							description: 'Make yourself comfortable and enjoy all the services we have provided for you.'
						}
						if(this.isLoggedIn){
							if(!this.isCurrentUserSameWithRsvUser){
								return_data.description = 'This reservation is connected to a guestaps account that is different from your current account. If you want to log in with that account, you can open a message containing the auto login url in your email'
							}
						}else{
							return_data.description = 'Your data has been validated. There are many offers if you log in with a Guestaps account, please check your email for automatic login to your Guestaps account'
						}
					}

					return return_data
				}else{
					return null
				}
			},
			is_load(){
				return this.data_parent.loading_section
			},
			show_booking_engine_section(){
				if(this.isReservationActive || !this.getMerchant.use_booking_engine) return false
				else return true
			}
		},
		watch:{
			concierge_status(){
				if(this.concierge_status == 'pin_not_match'){
					this.reservation_pin_error = 'Incorrect PIN, please try again'
				}else{
					this.reservation_pin_error = ''
				}
			}
		},
		mounted(){
      this.loadMerchantFeedback()
		},
		methods:{
			openGuestBill(){
				this.$refs.guest_bill.toggleDetail()
			},
			callClick(){
				this.$emit('callClick')
			},
			detailPromotion(){
      	this.$postLog("HOME","PROMOTION","Clicked promotion")
      },
      goToSearchRoom(){
      	this.$postLog("HOME","PREVIEW BOOK ROOM","Clicked book now")
      	this.$router.push(`/${this.getMerchant.code}/booking`)
      },
			printBestMenuPrice(product){
				let price = product.variant_list.length == 0 ? product.price : product.variant_list[0].price
				return calculateFinalPriceConcierge(price)
			},
			formatTime(time){
        return moment(time, 'HH:mm:ss').format('HH:mm')
      },
      toggleBurgerMenu(){
      	this.show_navbar = !this.show_navbar
      },
      toggleFacility(){
      	this.show_facility = !this.show_facility
      },
      togglePopupInfo(title='',body=''){
      	this.popup_info.show = !this.popup_info.show
    		this.popup_info.title = title
    		this.popup_info.body = body
    		this.$postLog('HOME','FOOTER',`Clicked detail ${title}`)
      },
      shareClick(){
        this.$emit("shareClick")
      },
      detailModuleClick(code){
      	this.$emit('detailModuleClick',code)
      },
      goToDetailSlider(slider){
      	this.$emit('goToDetailSlider',slider)
      },
      showGallery(data){
      	this.is_gallery = data
      	document.querySelector('body').style.overflow = data ? 'hidden' : 'auto';
      },
      isLocation(){
      	document.getElementById('location').scrollIntoView({
	          behavior: 'smooth'
	      });
      },
      formatCustomDate(data,frmt){
      	return moment(data).format(frmt)
      },
      goToCustomBookingPage(){
      	let cloned_data = this.$deepCopy(this.getBeFilter)
      	let parsed_url = this.getMerchant.custom_booking_engine_landing_page_url
  			let params = [
					{ name: "Checkin Date (DD)", parameter: "{{checkin_date}}", value: this.formatCustomDate(cloned_data.date.check_in,'DD') },
				  { name: "Checkin Month (MM)", parameter: "{{checkin_month}}", value: this.formatCustomDate(cloned_data.date.check_in,'MM') },
				  { name: "Checkin Year (YYYY)", parameter: "{{checkin_year}}", value: this.formatCustomDate(cloned_data.date.check_in,'YYYY') },
				  { name: "Checkout Date (DD)", parameter: "{{checkout_date}}", value: this.formatCustomDate(cloned_data.date.check_out,'DD') },
				  { name: "Checkout Month (MM)", parameter: "{{checkout_month}}", value: this.formatCustomDate(cloned_data.date.check_out,'MM') },
				  { name: "Checkout Year (YYYY)", parameter: "{{checkout_year}}", value: this.formatCustomDate(cloned_data.date.check_out,'YYYY') },
				  { name: "Total Night Stay", parameter: "{{total_night}}", value: moment.duration(moment(cloned_data.date.check_out).diff(moment(cloned_data.date.check_in))).days() },
				  { name: "Total Adult", parameter: "{{total_adult}}", value: cloned_data.guest.adult },
				  { name: "Total Child", parameter: "{{total_child}}", value: cloned_data.guest.child },
				  { name: "Total Infant", parameter: "{{total_infant}}", value: cloned_data.guest.infant },
				  { name: "Total Guest", parameter: "{{total_guest}}", value: Number(cloned_data.guest.adult)+Number(cloned_data.guest.child)+Number(cloned_data.guest.infant) },
				  { name: "Currency in ISO format", parameter: "{{currency_code}}", value: this.getCurrency.code },
				  { name: "Language Used", parameter: "{{langugae_code}}", value: this.getCurrentLanguage },
				  { name: "Promo Code", parameter: "{{promo_code}}", value: cloned_data.promo_code },
				]
  			params.forEach(item=>{
	        parsed_url = parsed_url.replaceAll(item.parameter,item.value)
	      })
	      this.$openLink(parsed_url,'_blank')
      },
      loadMerchantFeedback(){
        let params = {
          module: "CORE",
          uri: "merchant-ticket-feedback",
          data: {
            merchant: this.getMerchant.id,
          },
          session: ''
        }
	      get(params.module,params.uri,params.data,params.session).then(response=>{
	        let res = response.data
	        if (res.success) {
	          this.summary = res.data.feedback_summary.total
	        }
	      })
	    },
      openGmaps(){
        let tag_a = document.createElement('a')
        tag_a.href = `https://maps.google.com/?q=${this.getMerchant.lat},${this.getMerchant.lng}`
        tag_a.target = '_blank'
        tag_a.click()
        tag_a.remove()
      },
      checkStatus(){
      	this.$emit('checkReservationStatus')
      }
		}
	}
</script>
<style type="text/css">
.flickity-page-dots {
  bottom: 16px!important;
}
.flickity-page-dots .dot {
  width: 8px!important;
  height: 8px!important;
  margin: 0 2.5px!important;
  background: #fff!important;
  opacity: 0.50!important;
 }
 .flickity-page-dots .dot.is-selected{
 	opacity: 1!important;
 }
</style>


// WEBPACK FOOTER //
// src/pages/hotel/HotelHomePageMobile.vue